import { toast } from "react-toastify";
import { call, put, takeEvery } from "redux-saga/effects";
import {
  GET_PAYMENT_HASHED_FAILED,
  GET_PAYMENT_HASHED_REQUESTED,
  GET_PAYMENT_HASHED_SUCCESS,
  GET_PAYMENT_METHOD_FAILED,
  GET_PAYMENT_METHOD_REQUESTED,
  GET_PAYMENT_METHOD_SUCCESS,
  GET_PAYMENT_VERIFY_FAILED,
  GET_PAYMENT_VERIFY_REQUESTED,
  GET_PAYMENT_VERIFY_SUCCESS,
} from "resources/actionTypes";
import { paymentApi, paymentHashApi, paymentMethodApi } from "services/PaymentService";

function* fetchPaymentVerify(action) {
  const payload = action.payload || {};
  const userPaymentVerify = yield call(paymentApi, payload);
  if (userPaymentVerify?.success) {
    yield put({
      type: GET_PAYMENT_VERIFY_SUCCESS,
      userPaymentVerify: userPaymentVerify,
    });
    toast.success(userPaymentVerify?.message);
  } else {
    yield put({
      type: GET_PAYMENT_VERIFY_FAILED,
      message: userPaymentVerify?.message,
    });
      toast.error(userPaymentVerify?.message || "Payment Verify failed");
  }
}
export function* paymentVerifySaga(){
  yield takeEvery(GET_PAYMENT_VERIFY_REQUESTED,fetchPaymentVerify);
}

function* fetchPaymentHash(action){
  const payload = action.payload || {};
  const userPaymentHash = yield call(paymentHashApi,payload.userPaymentHash);
  if(userPaymentHash.success){
    yield put({type:GET_PAYMENT_HASHED_SUCCESS, userPaymentHash:userPaymentHash})
    
  }
  else{
    yield put({type:GET_PAYMENT_HASHED_FAILED,message:userPaymentHash?.message});
      toast.error(userPaymentHash?.message || "Fetching Payment failed");
  }
}
export function* paymentHashSaga(){
 yield takeEvery(GET_PAYMENT_HASHED_REQUESTED, fetchPaymentHash);
}
// Payment Method
function* fetchPaymentMethod(action) {
  const payload = action.payload || {};
  const userPaymentMethod = yield call(paymentMethodApi,payload?.userPaymentMethod);
  if (userPaymentMethod?.success) {
    yield put({
      type: GET_PAYMENT_METHOD_SUCCESS,
      userPaymentMethod: userPaymentMethod,
    });
    toast.success(userPaymentMethod?.message);
    localStorage.removeItem('trip');
  } else {
    yield put({
      type: GET_PAYMENT_METHOD_FAILED,
      message: userPaymentMethod?.message,
    });
      toast.error(userPaymentMethod?.message || "Payment Method failed");
  }
}
export function* paymentMethodSaga(){
  yield takeEvery(GET_PAYMENT_METHOD_REQUESTED,fetchPaymentMethod);
}